module.exports = function formatVolume(value) {
    if(!value)
        return '0';

    var unit = 'm³';
    if(value <= 1) {
        value *= 1000;
        unit = 'dm³';
    }

    return `${value}${unit}`;
};
